import { Outlet } from "react-router-dom";
import { ClubController } from "../../controllers/ClubController";
import { ApplicationView } from "@mixitone/mvc";
import { injectParams } from "lib/injectParams";

const ControlledClubPage = () => {
  return <Outlet />;
};

export const ClubPage = injectParams(ClubController.scope(ApplicationView(ControlledClubPage)));
